export default {
  unbind: function (el, binding, vnode) {
    // console.log('v-clear')
    // Find the elements record and clear it
    var record = binding && binding.value ? binding.value : false
    if (vnode.data.model && vnode.data.model.expression) record = vnode.data.model.expression
    if (record && record.startsWith('records.')) {
      record = record.substr(8)
    } else if (binding.arg == 'di') {
      record = vnode.componentInstance.di.name
    }
    if (!vnode.context.routeChanging && !vnode.context.questionnaireSaving) {
      if (vnode.data.model) vnode.data.model.callback()
      // vnode.context.$store.dispatch('questionnaires/updateRecord',{ field: record, value: null })
    }
  }
}